require('../bootstrap-slider.js');

require('./betlog.js')
require('./betform.js');
require('./chat.js');
